import React, { Fragment } from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './features.css'

const Features = (props) => {
  return (
    <div className="features-container1">
      <Helmet>
        <title>California Places</title>
        <meta property="og:title" content="California Places" />
        <link
          rel="canonical"
          href="https://copy-of-glass-outstanding-chamois-m7jub6.teleporthq.app/"
        />
        <meta
          property="og:url"
          content="https://copy-of-glass-outstanding-chamois-m7jub6.teleporthq.app/"
        />
      </Helmet>
      <div className="features-thq-container-elm1">
        <Navigation
          button={
            <Fragment>
              <span className="features-text10">Contact Us</span>
            </Fragment>
          }
          button1={
            <Fragment>
              <span className="features-text11">Pricing</span>
            </Fragment>
          }
          rootClassName="navigationroot-class-name"
        ></Navigation>
      </div>
      <section className="features-thq-hero-section-elm hero-section">
        <div className="hero-media-container features-thq-hero-media-container-elm">
          <div className="features-thq-hero-overlay-elm hero-overlay">
            <div
              data-thq="slider"
              data-autoplay="true"
              data-navigation="true"
              data-pagination="true"
              data-autoplay-delay="5000"
              data-pause-autoplay-on-mouse-enter="true"
              data-disable-autoplay-on-interaction="false"
              className="features-thq-slider-elm swiper"
            >
              <div data-thq="slider-wrapper" className="swiper-wrapper">
                <div
                  data-thq="slider-slide"
                  className="features-thq-slider-slide-elm1 swiper-slide"
                >
                  <img
                    alt="image"
                    src="/first_pdf_ad-1500h.png"
                    className="features-image10"
                  />
                </div>
                <div
                  data-thq="slider-slide"
                  className="features-thq-slider-slide-elm2 swiper-slide"
                >
                  <img
                    alt="image"
                    src="/it-is-an-idyllic-los-angeles-neighborhood---we-are(1)-1500h.png"
                    className="features-image11"
                  />
                </div>
                <div
                  data-thq="slider-slide"
                  className="features-thq-slider-slide-elm3 swiper-slide"
                >
                  <img
                    alt="image"
                    src="/a-high-resolution-image-of-the-sun-coming-up-over--1500h.png"
                    className="features-image12"
                  />
                </div>
                <div
                  data-thq="slider-slide"
                  className="features-thq-slider-slide-elm4 swiper-slide"
                >
                  <img
                    alt="image"
                    src="/map%20image2-1500h.png"
                    className="features-image13"
                  />
                </div>
                <div
                  data-thq="slider-slide"
                  className="features-thq-slider-slide-elm5 swiper-slide"
                >
                  <img
                    alt="image"
                    src="/map3-1200w.png"
                    className="features-image14"
                  />
                </div>
              </div>
              <div
                data-thq="slider-pagination"
                className="features-thq-slider-pagination-elm swiper-pagination swiper-pagination-bullets swiper-pagination-horizontal"
              >
                <div
                  data-thq="slider-pagination-bullet"
                  className="swiper-pagination-bullet"
                ></div>
                <div
                  data-thq="slider-pagination-bullet"
                  className="swiper-pagination-bullet"
                ></div>
                <div
                  data-thq="slider-pagination-bullet"
                  className="swiper-pagination-bullet"
                ></div>
                <div
                  data-thq="slider-pagination-bullet"
                  className="swiper-pagination-bullet"
                ></div>
              </div>
              <div
                data-thq="slider-button-prev"
                className="swiper-button-prev"
              ></div>
              <div
                data-thq="slider-button-next"
                className="swiper-button-next"
              ></div>
            </div>
          </div>
        </div>
      </section>
      <div className="features-thq-container-elm2">
        <div className="features-container2">
          <a
            href="https://apps.apple.com/us/app/california-places/id6757087852"
            className="features-link1"
          >
            <img
              alt="image"
              src="/applestore-200h.png"
              className="track-button-1"
            />
          </a>
        </div>
        <img alt="image" src="/2r8dwi-200h.png" className="features-image15" />
        <div className="features-container3">
          <a
            href="https://play.google.com/store/apps/details?id=focusreintel.com.focus&amp;hl=en_US"
            className="features-link2"
          >
            <img
              alt="image"
              src="/android-200h.png"
              className="track-button-2"
            />
          </a>
        </div>
      </div>
      <div className="features-thq-categories-header-elm categories-header">
        <div className="features-container4">
          <span className="features-text12">
            Whether you are a seasoned real estate professional or a potential
            buyer, California Places™ delivers fresh insights into a property or
            neighborhood&apos;s suitability.  Our data includes but is not
            limited to the following:
          </span>
        </div>
      </div>
      <div className="features-container5">
        <ul className="features-ul1 list">
          <li className="features-li10 list-item">
            <span>Owner Information</span>
          </li>
          <li className="features-li11 list-item">
            <span>Deed History</span>
          </li>
          <li className="features-li12 list-item">
            <span>Zoning Information</span>
          </li>
          <li className="features-li13 list-item">
            <span>Waste/Recycling Providers</span>
          </li>
          <li className="features-li14 list-item">
            <span>Elected Officals</span>
          </li>
          <li className="features-li15 list-item">
            <span>Government Dept. Info</span>
          </li>
          <li className="features-li16 list-item">
            <span>SB79 Eligibility</span>
          </li>
          <li className="features-li17 list-item">
            <span>USDA Plant Hardiness zones</span>
          </li>
          <li className="features-li18 list-item">
            <span>Traffic</span>
          </li>
          <li className="features-li19 list-item">
            <span>Nearby Well Completion Reports</span>
          </li>
          <li className="features-li20 list-item">
            <span className="features-text23">Tap Water Quality Reports</span>
          </li>
          <li className="features-li21 list-item">
            <span>Powerline Proximity</span>
          </li>
          <li className="features-li22 list-item">
            <span>Plus Much more...</span>
          </li>
        </ul>
        <ul className="features-ul2 list">
          <li className="features-li23 list-item">
            <span>Fire Hazard Zones</span>
          </li>
          <li className="features-li24 list-item">
            <span>Flood Zones</span>
          </li>
          <li className="features-li25 list-item">
            <span>Seismic Hazards</span>
          </li>
          <li className="features-li26 list-item">
            <span className="features-text29">
              Summertime Fog/Low Cloud Avg. Hrs.
            </span>
          </li>
          <li className="features-li27 list-item">
            <span className="features-text30">
              Tract/Block Group/Block Demographics
            </span>
          </li>
          <li className="features-li28 list-item">
            <span className="features-text31">Census Age/Income Data</span>
          </li>
          <li className="features-li29 list-item">
            <span>Census Ancestry/Race Data</span>
          </li>
          <li className="features-li30 list-item">
            <span>Public Schools Testing Info</span>
          </li>
          <li className="features-li31 list-item">
            <span>Noise/Light Pollution</span>
          </li>
          <li className="features-li32 list-item">
            <span>Local Hazmats/Toxic Releasers</span>
          </li>
          <li className="features-li33 list-item">
            <span>Groundwater Threats</span>
          </li>
          <li className="features-li34 list-item">
            <span>Air Pollution</span>
          </li>
          <li className="features-li35 list-item">
            <span>Plus Much More...</span>
          </li>
        </ul>
      </div>
      <animate-on-reveal
        animation="none"
        duration="300ms"
        delay="0s"
        direction="normal"
        easing="ease"
        iteration="1"
      >
        <div
          data-thq-animate-on-reveal="true"
          className="features-thq-showcase-scroller-inner-elm showcase-scroller-inner"
        >
          <div className="showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/simulator%20screenshot%20-%20iphone%20air%20-%202026-01-04%20at%2014.23.13-400w.png"
                className="features-image16"
              />
            </div>
            <div className="showcase-caption">
              <h4 className="section-subtitle">
                <span>Demographics</span>
                <br></br>
              </h4>
              <h4 className="section-subtitle">
                <span className="features-text41">Down to nearest block.</span>
                <br></br>
              </h4>
            </div>
            <ul className="features-thq-category-list-elm1 category-list">
              <li>
                <span>Age</span>
              </li>
              <li>
                <span>Income</span>
              </li>
              <li>
                <span>Ancestry/Race</span>
              </li>
              <li>
                <span> Other</span>
              </li>
            </ul>
          </div>
          <div className="showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/simulator%20screenshot%20-%20iphone%20air%20-%202026-01-04%20at%2014.52.50-400w.jpg"
                className="features-image17"
              />
            </div>
            <div className="showcase-caption">
              <h4 className="section-subtitle">Climate</h4>
            </div>
            <ul className="features-thq-category-list-elm2 category-list">
              <li>
                <span>Summer Fog Hours</span>
              </li>
              <li>
                <span>Historical Temps/Precip</span>
              </li>
              <li>
                <span>Plant Hardiness Zones</span>
              </li>
            </ul>
          </div>
          <div className="showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/simulator%20screenshot%20-%20iphone%20air%20-%202026-01-04%20at%2014.24.091-400w.jpg"
                className="features-image18"
              />
            </div>
            <div className="features-thq-showcase-caption-elm3 showcase-caption">
              <h4 className="features-thq-section-subtitle-elm4 section-subtitle">
                Environmental Risks
              </h4>
            </div>
            <ul className="features-thq-category-list-elm3 category-list">
              <li>
                <span>FEMA Flood Zones</span>
              </li>
              <li>
                <span>CalFire Hazard Map</span>
              </li>
              <li>
                <span>Fault Line Proximity</span>
              </li>
              <li>
                <span>Dam Breach Inundation Zones</span>
              </li>
            </ul>
          </div>
          <div className="showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/simulator%20screenshot%20-%20iphone%20air%20-%202026-01-04%20at%2014.15.27-400w.jpg"
                className="features-image19"
              />
            </div>
            <div className="showcase-caption">
              <h4 className="section-subtitle">Zoning</h4>
            </div>
            <ul className="features-thq-category-list-elm4 category-list">
              <li>
                <span>Nearby Hazmat Facilities</span>
              </li>
              <li>
                <span>Noise/Light Pollution</span>
              </li>
              <li>
                <span>Water Quality</span>
              </li>
              <li>
                <span>Nearby Toxic Releasers</span>
              </li>
            </ul>
          </div>
          <div className="showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/simulator%20screenshot%20-%20iphone%20air%20-%202026-01-04%20at%2014.16.071-400w.jpg"
                className="features-image20"
              />
            </div>
            <div className="showcase-caption">
              <h4 className="section-subtitle">Pollution</h4>
            </div>
            <ul className="features-thq-category-list-elm5 category-list">
              <li>
                <span>Nearby Hazmat Facilities</span>
              </li>
              <li>
                <span>Noise/Light Pollution</span>
              </li>
              <li>
                <span>Water Quality</span>
              </li>
              <li>
                <span>Nearby Toxic Releasers</span>
              </li>
            </ul>
          </div>
          <div className="showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/simulator%20screenshot%20-%20iphone%20air%20-%202026-01-04%20at%2014.22.51-400w.png"
                className="features-image21"
              />
            </div>
            <div className="showcase-caption">
              <h4 className="section-subtitle">Owner And Deed History</h4>
            </div>
            <ul className="features-thq-category-list-elm6 category-list">
              <li>
                <span>Owner Address</span>
              </li>
              <li>
                <span>Last Sales/Transfers</span>
              </li>
              <li>
                <span>Tax Information</span>
              </li>
              <li>
                <span>Price History</span>
              </li>
            </ul>
          </div>
          <div className="features-thq-showcase-card-elm7 showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/simulator%20screenshot%20-%20iphone%20air%20-%202026-01-04%20at%2014.24.28-400w.jpg"
                className="features-image22"
              />
            </div>
          </div>
          <div className="features-thq-showcase-card-elm8 showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/simulator%20screenshot%20-%20iphone%20air%20-%202026-01-04%20at%2015.04.08-400w.jpg"
                className="features-image23"
              />
            </div>
          </div>
          <div className="features-thq-showcase-card-elm9 showcase-card">
            <div className="showcase-image-wrapper">
              <img
                alt="image"
                src="/sb79-400w.jpg"
                className="features-image24"
              />
            </div>
          </div>
        </div>
      </animate-on-reveal>
      <Footer></Footer>
      <nav id="main-navigation" className="nav-container">
        <div className="nav-wrapper">
          <Link to="/">
            <div className="nav-logo-link">
              <img alt="Logo" src="/favicon.png" className="nav-logo-img" />
            </div>
          </Link>
          <div className="nav-desktop-links">
            <div className="nav-link">
              <span className="nav-link-text">Pricing</span>
              <span className="nav-link-underline"></span>
            </div>
            <Link to="/contact">
              <div className="nav-link">
                <span className="nav-link-text">Contact</span>
                <span className="nav-link-underline"></span>
              </div>
            </Link>
            <a href="/signup">
              <div className="nav-cta btn btn-primary">
                <span>Get Started</span>
              </div>
            </a>
          </div>
          <button
            id="mobile-menu-toggle"
            aria-label="Toggle Menu"
            className="nav-mobile-toggle"
          >
            <span className="icon-open">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M4 8h16M4 16h16"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </span>
            <span className="icon-close">
              <svg
                width="24"
                xmlns="http://www.w3.org/2000/svg"
                height="24"
                viewBox="0 0 24 24"
              >
                <path
                  d="M18 6L6 18M6 6l12 12"
                  fill="none"
                  stroke="white"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
            </span>
          </button>
        </div>
        <div id="mobile-menu-overlay" className="nav-mobile-overlay">
          <div className="nav-mobile-content">
            <div className="nav-mobile-links">
              <div className="nav-mobile-link">
                <span>Pricing</span>
              </div>
              <Link to="/contact">
                <div className="nav-mobile-link">
                  <span>Contact</span>
                </div>
              </Link>
              <div className="nav-mobile-divider"></div>
              <a href="/signup">
                <div className="btn btn-lg btn-primary">
                  <span>Get Started</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </nav>
      <div className="features-container6">
        <div className="features-container7">
          <Script
            html={`<script>
(function(){
  ;(function () {
    const toggleBtn = document.getElementById("mobile-menu-toggle")
    const navContainer = document.getElementById("main-navigation")
    const mobileLinks = document.querySelectorAll(".nav-mobile-link")

    if (toggleBtn && navContainer) {
      toggleBtn.addEventListener("click", () => {
        navContainer.classList.toggle("nav-is-open")

        // Prevent scrolling when menu is open
        if (navContainer.classList.contains("nav-is-open")) {
          document.body.style.overflow = "hidden"
        } else {
          document.body.style.overflow = ""
        }
      })

      // Close menu when a link is clicked
      mobileLinks.forEach((link) => {
        link.addEventListener("click", () => {
          navContainer.classList.remove("nav-is-open")
          document.body.style.overflow = ""
        })
      })
    }

    // Handle scroll effect
    window.addEventListener("scroll", () => {
      if (window.scrollY > 50) {
        navContainer.style.padding = "0"
        navContainer.style.boxShadow = "var(--shadow-level-2)"
      } else {
        navContainer.style.padding = ""
        navContainer.style.boxShadow = ""
      }
    })
  })()
})()
</script>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default Features
